import useIsRtl from "@/hooks/useIsRtl";
import { CSSProperties } from "react";
import useEmblaSlider from "./useEmblaSlider";
import { usePrevNextButtons } from "./EmblaSliderPrevNextButtons";
import { useIsMobile } from "@/hooks/useIsMobile";

const style = (rtl: boolean, isEnd: boolean): CSSProperties => {
  const width = 89;
  return {
    position: "absolute",
    width: width,
    height: "100%",
    top: 0,
    background:
      "linear-gradient(270deg, #FAFAFA 0%, rgba(250, 250, 250, 0) 100%)",
    marginInlineStart: isEnd ? `calc(100% - ${width}px)` : 0,
    transform: (isEnd && !rtl) || (!isEnd && rtl) ? "" : "scaleX(-2)",
    WebkitTransform: (isEnd && !rtl) || (!isEnd && rtl) ? "" : "scaleX(-2)",
  };
};
const EmblaFilters: React.FC<{ hidden?: boolean }> = ({ hidden = false }) => {
  const isRtl = useIsRtl();
  const isMobile = useIsMobile();
  const [, emblaApi] = useEmblaSlider()!;
  const { nextBtnDisabled, prevBtnDisabled } = usePrevNextButtons(emblaApi);

  return (
    !hidden &&
    !isMobile && (
      <>
        {!nextBtnDisabled && <div style={style(isRtl, true)} />}
        {!prevBtnDisabled && <div style={style(isRtl, false)} />}
      </>
    )
  );
};

export default EmblaFilters;
